<template>
	<div class="v5-spinner-lines" :style="{ 'height':size}">
		<div class="rect1"></div>
		<div class="rect2"></div>
		<div class="rect3"></div>
		<div class="rect4"></div>
	</div>
</template>

<script>
	export default {
		name: 'v5-spinner-lines',
		props: {
			size: {
				type: String,
				default: '38px'
			}
		}
	};

</script>

<style lang="scss">
	@import '../style.scss';
	.v5-spinner-lines {
		text-align: center;
		font-size: 12px;
	}

	.v5-spinner-lines>div {
		background-color: $color;
		height: 100%;
		width: 4px;
		border-radius: px2rem(4px);
		display: inline-block;
		animation: sk-stretchdelay 1.2s infinite ease-in-out;
	}

	.v5-spinner-lines .rect2 {
		animation-delay: -1.1s;
	}

	.v5-spinner-lines .rect3 {
		animation-delay: -1.0s;
	}

	.v5-spinner-lines .rect4 {
		animation-delay: -0.9s;
	}

	@keyframes sk-stretchdelay {
		0%,
		40%,
		100% {
			transform: scaleY(0.4);
		}
		20% {
			transform: scaleY(0.8);
		}
	}

</style>
